module.exports = __webpack_public_path__ + "static/media/centro_abajo_1.9a5f80a5.jpg";